import { Outlet } from 'react-router-dom';

import { useReportRoute } from '../helpers/hooks/useReportRoute';

export default function AuthLayout() {
  useReportRoute();

  return <Outlet />;
}
